import { GatsbyImage } from "gatsby-plugin-image"
import HTMLReactParser from "html-react-parser"
import React from "react"

import BackgroundLogo from "./deco/BackgroundLogo"

export default function TitleBlock({ component }) {
  const {
    title,
    subtitle,
    iconMedia,
    withPaddingBottom,
    withBackground,
    backgroundColor,
  } = component

  return (
    <div
      className={`${
        backgroundColor === "blue" ? "bg-charlestonGreen-100" : ""
      } relative overflow-hidden`}
    >
      {withBackground && (
        <div className="absolute right-2/3 absolute right-0 top-1/2 -translate-y-1/2">
          <BackgroundLogo />
        </div>
      )}
      <div
        className={`relative max-w-6xl mx-auto  px-4 text-center sm:px-6 lg:px-8  ${
          withPaddingBottom ? "py-10 lg:py-14" : "pt-10 lg:pt-14"
        }`}
      >
        <div className="space-y-12">
          <div className="space-y-5 sm:mx-auto sm:max-w-xl sm:space-y-4 lg:max-w-5xl">
            {iconMedia?.localFile?.childImageSharp?.gatsbyImageData && (
              <GatsbyImage
                className="w-8 h-8 "
                image={iconMedia?.localFile?.childImageSharp?.gatsbyImageData}
                alt={iconMedia?.altText}
              />
            )}
            {title && (
              <h2 className="text-3xl lg:text-4xl font-bold">{title}</h2>
            )}
            {subtitle && (
              <p className="text-xl text-charlestonGreen-500">
                {HTMLReactParser(subtitle)}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
